export function downloadBlob(filename, blob) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

// Saves a file response from the API and returns what the server reported about it.
export async function downloadResponse(res, fallbackName) {
  const disposition = res.headers.get("Content-Disposition") || "";
  const filename = disposition.match(/filename="([^"]+)"/)?.[1] || fallbackName;
  downloadBlob(filename, await res.blob());
  return {
    pages: Number(res.headers.get("X-Page-Count")) || 0,
    unmatched: (res.headers.get("X-Unmatched-Edits") || "").split(",").filter(Boolean),
  };
}

export function downloadText(filename, text) {
  downloadBlob(filename, new Blob([text], { type: "text/plain" }));
}

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
